import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { fmt } from "@/lib/format";

const typeLabel = {
  purchase: "Purchase",
  resale_buy: "Resale buy",
  resale_sell: "Resale sell",
  rental_payout: "Rental payout",
  referral_reward: "Referral reward",
  referral_welcome: "Welcome bonus",
  admin_credit: "Wallet credit",
  admin_debit: "Wallet debit",
};

export default function Transactions() {
  const [tx, setTx] = useState([]);

  useEffect(() => {
    api.get("/transactions").then(({ data }) => setTx(data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-10">
      <div className="overline">Ledger</div>
      <h1 className="font-heading text-4xl md:text-5xl font-light tracking-tight text-white mt-2 mb-8">
        Transactions
      </h1>

      <div className="bp-surface rounded-2xl overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow className="border-white/5 hover:bg-transparent">
              <TableHead className="overline">Type</TableHead>
              <TableHead className="overline">Property</TableHead>
              <TableHead className="overline">Bricks</TableHead>
              <TableHead className="overline">Amount</TableHead>
              <TableHead className="overline">Date</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {tx.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} className="text-center py-12 text-gray-500">
                  No transactions yet
                </TableCell>
              </TableRow>
            ) : (
              tx.map((t) => (
                <TableRow key={t.id} className="border-white/5" data-testid={`tx-${t.id}`}>
                  <TableCell className="text-white text-sm">{typeLabel[t.type] || t.type}</TableCell>
                  <TableCell className="text-gray-300 text-sm">{t.property_name || "-"}</TableCell>
                  <TableCell className="font-mono text-sm text-white">{t.brick_count}</TableCell>
                  <TableCell className="font-mono text-[#D4AF37]">{fmt(t.amount, { decimals: true })}</TableCell>
                  <TableCell className="text-xs text-gray-500">
                    {new Date(t.created_at).toLocaleString()}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
